import _extends from "@babel/runtime-corejs3/helpers/extends";
import { useInstance, onMounted, onUnmounted, nextTick } from 'intact-vue';
import { useState, watchState } from '../../hooks/useState';
import { isNullOrUndefined } from 'intact-shared';
import ResizeObserver from 'resize-observer-polyfill';
import { useReceive } from '../../hooks/useReceive';
export function useStyle(elementRef) {
  var instance = useInstance();
  var style = useState(null);
  var containerStyle = useState(null);
  var ro = null;
  function genStyle() {
    var _instance$get = instance.get(),
      offsetTop = _instance$get.top,
      offsetBottom = _instance$get.bottom,
      exclude = _instance$get.exclude,
      shouldFix = _instance$get.shouldFix;
    var _elementRef$value$get = elementRef.value.getBoundingClientRect(),
      top = _elementRef$value$get.top,
      bottom = _elementRef$value$get.bottom,
      width = _elementRef$value$get.width,
      height = _elementRef$value$get.height;
    var setStyle = function setStyle(styles) {
      if (!exclude || exclude && !exclude({
        offsetTop: offsetTop,
        offsetBottom: offsetBottom,
        top: top,
        bottom: bottom,
        width: width,
        height: height
      })) {
        style.set(_extends({
          position: 'fixed',
          width: width + "px"
        }, styles));
        containerStyle.set({
          height: height + "px"
        });
      } else {
        resetStyle();
      }
    };
    if (isNullOrUndefined(offsetTop) && isNullOrUndefined(offsetBottom)) {
      offsetTop = 0;
    }
    if (!isNullOrUndefined(offsetTop)) {
      if (shouldFix && shouldFix({
        offsetTop: offsetTop,
        offsetBottom: offsetBottom
      }) || !shouldFix && top < offsetTop) {
        return setStyle({
          top: offsetTop + "px"
        });
      }
    } else {
      var viewportHeight = document.documentElement.clientHeight;
      if (shouldFix && shouldFix({
        offsetTop: offsetTop,
        offsetBottom: offsetBottom,
        viewportHeight: viewportHeight
      }) || !shouldFix && !isNullOrUndefined(offsetBottom) && viewportHeight - bottom <= offsetBottom) {
        return setStyle({
          bottom: offsetBottom + "px"
        });
      }
    }
    resetStyle();
  }
  function resetStyle() {
    style.set(null);
    containerStyle.set(null);
  }
  function observe() {
    ro = new ResizeObserver(function () {
      style.set(_extends({}, style.value, {
        width: elementRef.value.offsetWidth + 'px'
      }));
    });
    ro.observe(elementRef.value);
  }
  function disconnect() {
    if (ro) {
      ro.disconnect();
    }
  }
  watchState(style, function (newStyle, oldStyle) {
    nextTick(function () {
      if (newStyle && !oldStyle) {
        instance.trigger('change', true);
        observe();
      } else if (!newStyle) {
        instance.trigger('change', false);
        disconnect();
      }
    });
  });
  onMounted(function () {
    genStyle();
    window.addEventListener('scroll', genStyle);
    window.addEventListener('resize', genStyle);
  });
  onUnmounted(function () {
    window.removeEventListener('scroll', genStyle);
    window.removeEventListener('resize', genStyle);
    disconnect();
  });
  useReceive(['top', 'bottom'], genStyle, true);
  return {
    style: style,
    containerStyle: containerStyle
  };
}